import { useCallback, useState } from 'react';
import { useReactFlow } from 'react-flow-renderer';
import {AiOutlineArrowDown, AiOutlineArrowUp, AiOutlineArrowLeft, AiOutlineArrowRight} from 'react-icons/ai'


export const Sidebar = () => {
    
    const [increase, setIncrease] = useState(200);
    const {setViewport} = useReactFlow();
    


    const handleTransformArrowDown = useCallback(
        (increaseProp) => {
            setIncrease(increase + increaseProp);
            setViewport({ x: 0, y: -increase }, { duration: 800 });
        },
        [setViewport, increase]
    );
    
    const handleTransformArrowUp = useCallback(
        (decrease) => {
            setIncrease(increase - decrease);
            setViewport({ x: 0, y: -increase }, { duration: 800 });
        },
        [setViewport, increase]
    );
  
    return (
    <aside className='h-100 m-auto d-flex justify-content-center  align-items-center'>
        <div className='controls d-flex flex-row flex-md-column gap-5 mt-3 mt-md-0'>
            <AiOutlineArrowUp 
                onClick={()=>handleTransformArrowUp(200)}
                cursor='n-resize'
                className='fs-2'
            />

            <AiOutlineArrowDown 
                onClick={()=>handleTransformArrowDown(200)}
                className='arrow-down fs-2'
                cursor={'s-resize'}
            />

            <AiOutlineArrowLeft 
                className='arrow-left fs-2'
                cursor={'w-resize'}
            />
            <AiOutlineArrowRight 
                className='arrow-right fs-2'
                cursor={'e-resize'}
            />
        </div>
    </aside>
  )
}
